import {
  Box,
  Button,
  IconButton,
  Link as MuiLink,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import useCookieConsent from "../hooks/useCookieConsent";
import { frontendRoutes } from "../utility/frontendRoutes";

// UK/EEA-only — see useCookieConsent's isConsentRequiredMarket. Other
// markets never render this and get analytics immediately, unchanged.
const CookieConsentBanner = () => {
  const { isBannerOpen, accept, reject, dismiss } = useCookieConsent();

  if (!isBannerOpen) return null;

  return (
    <Box
      role="dialog"
      aria-label="Cookie preferences"
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1400,
        bgcolor: "white",
        borderTop: "1px solid #e5e7eb",
        boxShadow: "0 -2px 12px rgba(0,0,0,0.08)",
      }}
    >
      <Box
        sx={{
          maxWidth: 1100,
          mx: "auto",
          px: { xs: 2, md: 4 },
          py: 2,
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "stretch", sm: "center" },
          justifyContent: "space-between",
          gap: 1.5,
        }}
      >
        <Typography variant="body2" sx={{ color: "#374151", flex: 1 }}>
          We use PostHog for product analytics. For UK/EEA visitors, this is
          off until you accept. See our{" "}
          <MuiLink
            href={frontendRoutes.PRIVACY_POLICY}
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </MuiLink>{" "}
          for details.
        </Typography>
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 1, flexShrink: 0 }}
        >
          <Button variant="outlined" onClick={reject} size="small">
            Reject non-essential
          </Button>
          <Button
            variant="contained"
            onClick={accept}
            size="small"
            sx={{ bgcolor: "#046287", "&:hover": { bgcolor: "#035373" } }}
          >
            Accept
          </Button>
          <IconButton
            onClick={dismiss}
            size="small"
            aria-label="Close"
            sx={{ ml: "auto" }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default CookieConsentBanner;
